export const animation = {
  maskShowDuration: 0.5,
  maskHideDuration: 0.5,
  lineDuration: 0.06,
  wordDuration: 0.04,
  charDuration: 0.005,
  rootMargin: '0px 0px -15% 0px',
}
